import { Fragment, useEffect, useState } from "react";
import { Switch, alpha, styled } from "@mui/material";
import { yellow } from "@mui/material/colors";
import { Dialog, Transition } from "@headlessui/react";
import { loadingHide, loadingShow } from "../../../helper/loading";
import { duplicateProjectModalSubmit } from "../../../services/projects";
import {
  notifyError,
  notifySuccess,
} from "../../../helper/notification-helper";
import { useDispatch } from "react-redux";
import { getActiveProjects } from "../../../store/slices/projects";

const YSwitch = styled(Switch)(({ theme }) => ({
  "& .MuiSwitch-switchBase.Mui-checked": {
    color: yellow[600],
    "&:hover": {
      backgroundColor: alpha(yellow[600], theme.palette.action.hoverOpacity),
    },
  },
  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
    backgroundColor: yellow[600],
  },
}));
const organizationId = JSON.parse(localStorage.getItem("organizationID"));

const DuplicateProject = ({ allowCreateTask, selectedProject }) => {
  const dispatch = useDispatch();
  const [newProjectName, setNewProjectName] = useState(null);

  const [addAllMembersToggle, setAddAllMembersToggle] = useState(1);
  const [duplicateAllTasksToggle, setDuplicateAllTasksToggle] = useState(1);
  const [addAllTaskAssigneesToggle, setAddAllTaskAssigneesToggle] = useState(1);
  const [duplicateCompletedTaskToggle, setDuplicateCompletedTaskToggle] =
    useState(1);

  const [duplicateModalDisplayStatus, setDuplicateModalDisplayStatus] =
    useState(false);

  const [validations, setValidations] = useState(null);

  function closeModal() {
    setDuplicateModalDisplayStatus(false);
  }

  useEffect(() => {
    if (duplicateModalDisplayStatus === true) {
      if (newProjectName === null && selectedProject !== null) {
        setNewProjectName(selectedProject.name + " (copy)");
      }
    }
  }, [duplicateModalDisplayStatus]);

  function submit() {

    if (checkValidation()) {
      loadingShow(".modal-loading");
      let duplicateProjectObj = {
        organization_id: organizationId,
        new_project_name: newProjectName,
        add_all_project_members: addAllMembersToggle,
        duplicate_all_tasks: duplicateAllTasksToggle,
        add_all_task_assignees: addAllTaskAssigneesToggle,
        duplicate_completed_task: duplicateCompletedTaskToggle,
      };

      duplicateProjectModalSubmit(
        organizationId,
        selectedProject?.id,
        duplicateProjectObj
      ).then((response) => {
        if (response.code == 201) {
          notifySuccess("Project Duplicated Successfully");
          closeModal();
          dispatch(getActiveProjects(organizationId));
        } else {
          notifyError("Error in Project Duplicating !");
          closeModal();
        }
      });
    } else {
      loadingHide(".modal-loading");
      console.log("Faild...!");
    }
  }

  function checkValidation() {
    let validation = {};

    if (newProjectName === null || newProjectName === "") {
      validation.new_project_name = "Required";
    }

    setValidations(validation);

    if (Object.keys(validation).length === 0) {
      return true;
    } else {
      return false;
    }
  }

  return (
    <>
      <div className="order-last flex flex-row mt-1 lg:w-auto w-full">
        {allowCreateTask && selectedProject !== null ? (
          <button
            className={
              "flex flex-row bg-[#FBE77F] py-[11px] rounded w-fill px-[10px] h-[38px]  border-[#7F8290] lg:w-auto w-full  mt-5"
            }
            onClick={() => {
              setDuplicateModalDisplayStatus(true);
              // setDuplicateModalData({
              //     ...duplicateModalData,
              //     formData: {
              //         projectId: selectedProject.id,
              //     },
              //     modals: {
              //         type: "duplicate",
              //         show: true,
              //     },
              // })
            }}
          >
            <div className="pr-[10px]">
              <svg
                width="16"
                height="18"
                viewBox="0 0 16 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M11.996 3.63816C11.996 2.94985 11.5277 2.31907 10.8872 2.14113C10.7217 2.09478 10.5444 2.0788 10.3722 2.07507C9.95119 2.06601 9.52968 2.0724 9.09172 2.0724C9.09172 1.86783 9.09378 1.67923 9.09172 1.49011C9.08915 1.30205 9.01822 1.20349 8.8419 1.1582C8.76583 1.13849 8.68409 1.13529 8.60545 1.13476C8.31245 1.1321 8.01893 1.12943 7.72542 1.13583C7.63032 1.13796 7.58715 1.1028 7.55116 1.01383C7.3512 0.527957 6.99806 0.218961 6.51024 0.0740525C6.41052 0.0442184 6.30874 0.0245066 6.20748 0H5.70064C5.67802 0.00905678 5.65643 0.0229083 5.6333 0.0277031C5.06067 0.143843 4.65047 0.475747 4.40836 1.02501C4.37083 1.10919 4.32766 1.13743 4.24078 1.13583C3.91746 1.13263 3.59464 1.12943 3.27183 1.13902C3.00659 1.14648 2.90635 1.26369 2.90532 1.53433C2.90532 1.70854 2.90532 1.88221 2.90532 2.06601C2.84261 2.06868 2.79429 2.07294 2.74597 2.07294C2.36302 2.07294 1.98006 2.07294 1.59762 2.07294C0.665678 2.07613 0.000517579 2.76658 3.54536e-06 3.72873V9.5874C3.54536e-06 11.1739 0.00154565 12.761 3.54536e-06 14.3481C-0.00102452 14.8782 0.221552 15.2767 0.643574 15.5627C0.930919 15.7572 1.25013 15.8334 1.59145 15.8334C4.52967 15.8318 7.46789 15.8334 10.4061 15.8307C10.53 15.8307 10.6544 15.8201 10.7767 15.8004C11.4794 15.6858 11.9976 15.0902 11.9981 14.3822C12.0006 10.8015 12.0006 7.22039 11.9981 3.63923L11.996 3.63816ZM3.64245 1.88594H4.53224C4.7908 1.88488 4.91468 1.78738 4.98408 1.52953C5.11053 1.06231 5.47087 0.738927 5.90266 0.705896C6.37814 0.669136 6.81507 0.997844 6.94923 1.49277C7.03302 1.8007 7.13994 1.88488 7.44836 1.88541H8.34997V3.38404H3.64245V1.88541V1.88594ZM11.2743 3.76602V14.2612C11.2743 14.7359 11.0445 15.0066 10.5876 15.0662C10.5141 15.0758 10.439 15.079 10.365 15.079C7.45144 15.079 4.53892 15.0801 1.62538 15.0769C1.48813 15.0769 1.34523 15.0614 1.21467 15.0199C0.884656 14.9155 0.722735 14.6736 0.722735 14.3156C0.722735 10.776 0.722735 7.2369 0.722735 3.6973C0.722735 3.23647 1.02499 2.86461 1.45678 2.83957C1.90296 2.814 2.3512 2.82944 2.7984 2.82731C2.8277 2.82731 2.85649 2.83371 2.90481 2.83957V3.64083C2.90481 4.00896 3.03486 4.14481 3.38852 4.14481C5.12338 4.14481 6.85825 4.14481 8.59362 4.14481C8.95242 4.14481 9.09121 4.00203 9.09172 3.6339C9.09275 3.38191 9.09378 3.12938 9.09532 2.87686C9.09532 2.86727 9.102 2.85821 9.1092 2.83903C9.6037 2.83903 10.091 2.81879 10.5752 2.84543C10.9628 2.86727 11.2584 3.2338 11.2738 3.64189C11.2753 3.68291 11.2738 3.72447 11.2738 3.76549L11.2743 3.76602Z"
                  fill="#171923"
                />
                <path
                  d="M9.88829 6.96147C9.82507 6.97372 9.75927 6.97425 9.69553 6.97425C8.38423 6.97532 7.07293 6.97425 5.76214 6.97425C5.71228 6.97425 5.66242 6.97532 5.61358 6.96946C5.40797 6.94655 5.27432 6.79525 5.27689 6.59067C5.27946 6.38929 5.42082 6.23426 5.62489 6.22147C5.7534 6.21348 5.88294 6.21881 6.01247 6.21881H7.72626C8.40633 6.21881 9.08691 6.21881 9.76698 6.21881C9.97619 6.21881 10.1206 6.3211 10.1684 6.49478C10.225 6.70415 10.0975 6.92151 9.88932 6.96093L9.88829 6.96147Z"
                  fill="#171923"
                />
                <path
                  d="M9.88792 12.9922C9.82521 13.005 9.75941 13.0071 9.69516 13.0071C9.03411 13.0082 8.37357 13.0071 7.71304 13.0071C7.05251 13.0071 6.37193 13.0087 5.70163 13.0061C5.45026 13.005 5.29554 12.8777 5.27755 12.6678C5.26058 12.4669 5.37419 12.3028 5.56386 12.2597C5.60242 12.2511 5.64302 12.249 5.68261 12.249C7.04325 12.2479 8.40442 12.2474 9.76558 12.249C10.0061 12.249 10.165 12.3897 10.1773 12.6017C10.1881 12.7956 10.0719 12.9554 9.88792 12.9917V12.9922Z"
                  fill="#171923"
                />
                <path
                  d="M9.78348 9.9875C9.23243 9.99016 8.68087 9.98856 8.12983 9.98856H7.71295C7.03236 9.98856 6.35178 9.98963 5.67172 9.98856C5.42961 9.9875 5.27334 9.83353 5.27591 9.60711C5.27848 9.41426 5.40956 9.26455 5.59461 9.24324C5.62391 9.24005 5.65424 9.23845 5.68405 9.23845C7.0447 9.23845 8.40586 9.23845 9.76651 9.23845C10.0009 9.23845 10.15 9.35885 10.1752 9.55757C10.207 9.8005 10.041 9.98697 9.78399 9.98803L9.78348 9.9875Z"
                  fill="#171923"
                />
                <path
                  d="M4.58534 8.96301C4.1772 9.3695 3.76546 9.77172 3.35474 10.1756C3.28997 10.2389 3.22726 10.3061 3.15838 10.3647C3.00211 10.4979 2.81758 10.4957 2.67467 10.3492C2.42074 10.0882 2.17041 9.8234 1.92624 9.5533C1.77923 9.39134 1.78642 9.15107 1.92778 9.00989C2.07223 8.86551 2.28144 8.88043 2.44799 9.04185C2.61093 9.20061 2.77697 9.35458 2.95637 9.52506C3.30025 9.18463 3.66059 8.82449 4.02658 8.47074C4.09289 8.40628 4.1772 8.34715 4.26304 8.32211C4.42136 8.27576 4.58431 8.36526 4.6645 8.5155C4.74572 8.66946 4.72361 8.82609 4.58585 8.96301H4.58534Z"
                  fill="#171923"
                />
                <path
                  d="M4.59035 5.94231C4.12155 6.40953 3.64966 6.87303 3.17418 7.33333C3.00815 7.49422 2.82053 7.48516 2.65963 7.31734C2.42112 7.06961 2.18467 6.81975 1.95181 6.5667C1.78218 6.3829 1.77755 6.13943 1.93279 5.98972C2.08083 5.84801 2.2993 5.87625 2.47458 6.05472C2.62622 6.20869 2.783 6.35732 2.94698 6.51768C3.26414 6.20442 3.59415 5.87891 3.92416 5.55393C3.97813 5.50066 4.03005 5.44525 4.08659 5.39464C4.25211 5.24867 4.46081 5.25985 4.60731 5.41968C4.74918 5.57471 4.74867 5.78408 4.59035 5.94231Z"
                  fill="#171923"
                />
                <path
                  d="M4.60158 11.9597C4.12764 12.4365 3.64805 12.9064 3.16537 13.3726C3.00653 13.5266 2.81737 13.5122 2.66161 13.3497C2.42362 13.1019 2.18716 12.8521 1.95379 12.5996C1.78364 12.4152 1.77748 12.1723 1.93117 12.0215C2.07819 11.8782 2.29819 11.9059 2.47348 12.0828C2.62563 12.2368 2.78293 12.3854 2.94896 12.5474C3.31238 12.1883 3.68249 11.8223 4.05362 11.4584C4.20475 11.3098 4.35844 11.2831 4.51317 11.3737C4.73266 11.5021 4.78303 11.7775 4.60261 11.9592L4.60158 11.9597Z"
                  fill="#171923"
                />
                <circle cx="11.2422" cy="14" r="4" fill="white" />
                <path
                  d="M11.6866 12.2222H10.7977V13.5556H9.46441V14.4444H10.7977V15.7778H11.6866V14.4444H13.02V13.5556H11.6866V12.2222ZM11.2422 10C9.03774 10 7.24219 11.7956 7.24219 14C7.24219 16.2044 9.03774 18 11.2422 18C13.4466 18 15.2422 16.2044 15.2422 14C15.2422 11.7956 13.4466 10 11.2422 10ZM11.2422 17.1111C9.52663 17.1111 8.13108 15.7156 8.13108 14C8.13108 12.2844 9.52663 10.8889 11.2422 10.8889C12.9577 10.8889 14.3533 12.2844 14.3533 14C14.3533 15.7156 12.9577 17.1111 11.2422 17.1111Z"
                  fill="#171923"
                />
              </svg>
            </div>

            <span className="text-[171923] leading-[17px] font-bold">
              Duplicate project
            </span>
          </button>
        ) : null}
      </div>

      {duplicateModalDisplayStatus ? (
        <>
          <Transition appear show={duplicateModalDisplayStatus} as={Fragment}>
            <Dialog
              as="div"
              className="fixed inset-0 z-10 overflow-y-auto bg-gray-600/60"
              onClose={closeModal}
            >
              <div className="min-h-screen px-4 text-center">
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0"
                  enterTo="opacity-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100"
                  leaveTo="opacity-0"
                >
                  <Dialog.Overlay className="fixed inset-0" />
                </Transition.Child>

                <span className=" inline-block h-screen" aria-hidden="true">
                  &#8203;
                </span>
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 scale-95"
                  enterTo="opacity-100 scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 scale-100"
                  leaveTo="opacity-0 scale-95"
                >
                  <div className="modal-loading inline-block w-full max-w-md p-6 my-8  text-left align-middle transition-all transform bg-white drop-shadow-2xl rounded">
                    <Dialog.Title as="h3" className="ht-modal-header">
                      Duplicate Project
                    </Dialog.Title>

                    <div className="mt-2">
                      <div className="pb-2 border-b border-gray-100 mb-3">
                        <div className="w-full py-2">
                          <div>
                            <label className="uppercase font-bold">
                              New Project Name{" "}
                              <span className="required">*</span>
                            </label>
                            <input
                              name="new_project_name_field"
                              id="new_project_name_field"
                              placeholder="New Project Name"
                              className={`modal-input ${
                                validations !== null &&
                                validations.new_project_name !== undefined
                                  ? "modal-input-danger"
                                  : ""
                              }`}
                              autoComplete="off"
                              defaultValue={newProjectName}
                              onKeyUp={(event) => {
                                setNewProjectName(event.target.value);
                              }}
                            />
                            {validations !== null &&
                            validations.new_project_name !== undefined ? (
                              <div className="p-1 text-red-600 font-bold my-1">
                                {validations.new_project_name}
                              </div>
                            ) : null}
                          </div>
                        </div>

                        <div className="py-2">
                          <div className="w-full">
                            <YSwitch
                              checked={addAllMembersToggle}
                              onClick={(event) => {
                                if (event.target.checked === true) {
                                  setAddAllMembersToggle(1);
                                } else {
                                  setAddAllMembersToggle(0);
                                }
                              }}
                            />
                            <span className="">Add all Project Members</span>
                          </div>

                          <div className="w-full">
                            <YSwitch
                              checked={duplicateAllTasksToggle}
                              onClick={(event) => {
                                if (event.target.checked === true) {
                                  setDuplicateAllTasksToggle(1);
                                } else {
                                  setDuplicateAllTasksToggle(0);
                                }
                              }}
                            />
                            <span className="">Duplicate all tasks</span>
                          </div>

                          <div className="w-full">
                            <YSwitch
                              checked={addAllTaskAssigneesToggle}
                              onClick={(event) => {
                                if (event.target.checked === true) {
                                  setAddAllTaskAssigneesToggle(1);
                                } else {
                                  setAddAllTaskAssigneesToggle(0);
                                }
                              }}
                            />
                            <span className="">Add all Task Assignees</span>
                          </div>

                          <div className="w-full">
                            <YSwitch
                              checked={duplicateCompletedTaskToggle}
                              onClick={(event) => {
                                if (event.target.checked === true) {
                                  setDuplicateCompletedTaskToggle(1);
                                } else {
                                  setDuplicateCompletedTaskToggle(0);
                                }
                              }}
                            />
                            <span className="">Duplicate completed task</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="mt-4 flex justify-end">
                      <button
                        type="button"
                        className="ht-btn-black"
                        onClick={closeModal}
                      >
                        Close
                      </button>
                      <button
                        type="submit"
                        className={
                          "ht-btn-yellow"
                          // +
                          // (dataSendStatus
                          //   ? "opacity-50 cursor-not-allowed disabled"
                          //   : "")
                        }
                        onClick={() => {
                          submit();
                        }}
                      >
                        Save
                      </button>
                    </div>
                  </div>
                </Transition.Child>
              </div>
            </Dialog>
          </Transition>
        </>
      ) : null}
    </>
  );
};

export default DuplicateProject;
